import { useDestinationsContext } from '../../../../../Contexts/DestinationsContext'
import React, { useState } from 'react'
import { MoveDropdown } from '../MoveDropdown'
import { Popover } from 'antd'
import { CaretDownFilled, EnvironmentOutlined, WarningFilled } from '@ant-design/icons'

export const DestinationSwitcher = ({ container, index, editable, isError }) => {
  const { orderDestinations } = useDestinationsContext()
  const [optionsVisible, setOptionsVisible] = useState(false)
  const canMove =
    (orderDestinations.length > 1 && editable) || container.targets.some((t) => t?.location_name === 'N/A')
  const canMoveClass = canMove ? '' : 'disabled'
  const content = (
    <div>
      <MoveDropdown
        isMulti={container.targets.length > 1}
        pocketProduct={container.product_name}
        pocketStore={container.targets.length > 1 ? '' : container.targets[0]?.location_name}
        pocketIndex={index}
        setOptionsVisible={setOptionsVisible}
      />
    </div>
  )
  return (
    <Popover
      visible={optionsVisible}
      onOpenChange={(visible) => setOptionsVisible(visible)}
      placement='topLeft'
      title={<span>Change Destination</span>}
      content={content}
      trigger='click'
    >
      <div className={`pocket-status ${canMoveClass} `}>
        {isError ? (
          <span>
            <WarningFilled style={{ paddingRight: '0.5em' }} />
          </span>
        ) : (
          <span>
            <EnvironmentOutlined style={{ paddingRight: '0.5em' }} />
          </span>
        )}

        {container.targets.length > 1 ? 'Multi' : container.targets[0].location_name}
        {canMove && (
          <span>
            <CaretDownFilled style={{ paddingLeft: '0.5em' }} />
          </span>
        )}
      </div>
    </Popover>
  )
}
